/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_ACT,
  screenData: data,
});

export const dispatchMfgSelected = (payload) => ({
  type: actionTypes.SEARCH_MFG_DISP_ACTIVITY,
  payload,
});

export const setPaginationIndex = (value) => ({
  type: actionTypes.SET_PAGINATION_INDEX_DISPUTE_ACTIVITY,
  payload: value,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_ACT,
  detailScrData: data,
});
// dispatch dispute Code
export const dispatchDisputeCode = (data) => ({
  type: actionTypes.DISPLAY_DISPUTE_CODE,
  payload: data,
});
// dispatch all labeler data
export const dispatchLabelerData = (data) => ({
  type: actionTypes.GET_ALL_LABELER_ACT,
  payload: data,
});
// select option dispatch
export const getSelectedOption = (data) => ({
  type: actionTypes.SELECT_OPTION,
  payload: data,
});
// Manufactuerer Name Display
export const getManufactureName = (value) => ({
  type: actionTypes.GET_MANUFACTURER_NAME_ACT,
  allManufacturer: value,
});
// Manufacturer ID display
export const getManufactureID = (value) => ({
  type: actionTypes.GET_MANUFACTURER_ID_ACT,
  manufactureWithIds: value,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_ACT,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgDisputeActivity = (data) => ({
  type: actionTypes.GET_ERROR_MSG_DISPUTE_ACTIVITY,
  payload: data,
}); 
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgDisputeActivity({ searchScreenErrors: [] }));
  // }, 5000);
  dispatch(
    dispatchErrorMsgDisputeActivity({
      searchScreenErrors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};
// dispatch Display screen Object
export const dispatchDisplayObjActivity = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_ACTIVITY,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_ACT,
  payload: data,
});

//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

// manufacturer griddispatch (display screen)
export const dispatchMfgGrid = (data) => ({
  type: actionTypes.GRID_MFG_ACT,
  payload: data,
});
// NDC grid dispatch
export const dispatchNdcGrid = (data) => ({
  type: actionTypes.GRID_NDC_ACT,
  payload: data,
});
// status dispatch
export const dispatchStatus = (data) => ({
  type: actionTypes.SET_STATUS_ACT,
  payload: data,
});
// selected Code dispatch
export const dispatchSelectedCode = (data) => ({
  type: actionTypes.SELECTED_DISPUTE_CODE,
  payload: data,
});
// drug data dispatch
export const dispatchDrugData = (data) => ({
  type: actionTypes.GET_DRUG_DATA_ACT,
  payload: data,
});
// on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_ACT,
  payload: data,
});
// Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      return dispatch({
        type: actionTypes.MANUFACTURER_GRID_ACT,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch([]);
      return response;
    });
};
// manufacturer grid (display screen)
export const getMFGGrid =
  (value, fromDisplay = false) =>
  (dispatch) => {
    dispatch(dispatchMfgGrid([]));
    return axios
      .post(serviceEndPoint.DISPUTE_ACTIVITY_GRID_MFG, value)
      .then((response) => {
        if (response?.data?.rebateDisputeActivityGridNdcVO?.length === 0) {
          if (!fromDisplay) {
            dispatch(showNoDataMessage());
          }
        } else {
          dispatch(dispatchMfgGrid(response.data));
        }
        return response?.data?.rebateDisputeActivityGridNdcVO;
      })
      .catch((response) => {
        dispatch(dispatchMfgGrid([]));
      });
  };
// ndc grid (display screen)
export const getNDCGrid = (value) => (dispatch) => {
  dispatch(dispatchNdcGrid([]));
  return axios
    .post(serviceEndPoint.DISPUTE_ACTIVITY_GRID_NDC, value)
    .then((response) => {
      if (response?.data?.rebateDisputeActivityGridNdcVO?.length === 0) {
        dispatch(dispatchNdcGrid([]));
      } else {
        dispatch(dispatchNdcGrid(response.data));
      }
      return response?.data?.rebateDisputeActivityGridNdcVO;
    })
    .catch((response) => {
      dispatch(dispatchNdcGrid([]));
    });
};
// selected code
export const getSelectedCode = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REFERENCE_DATA, value)
    .then((response) => {
      return dispatch(dispatchSelectedCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSelectedCode([]));
    });
};
export const dispatchErrorMsgNDCDetail = (data) => ({
  type: actionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});
// refresh ndc details
export const refreshDisputeActivity = () => ({
  type: actionTypes.REFRESH_DISPUTE_ACTIVITY,
  payload: {},
});
export const refreshDisputeActivityDisplay = () => ({
  type: actionTypes.REFRESH_DISPUTE_ACTIVITY_DISPLAY,
  payload: {},
});
//
export const setMfgCount = (data) => ({
  type: actionTypes.SET_MFG_COUNT,
  payload: data,
});
// export all
export const setDisputeActivityExportAll = (data, key) => ({
  type: actionTypes.SET_EXPORT_ALL_DISPUTE_ACTIVITY,
  payload: { data, key },
});
export const reportData = (values, i) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_ACTIVITY_GRID_MFG, values)
    .then((response) => {
      dispatch(
        setDisputeActivityExportAll(
          response?.data?.rebateDisputeActivityGridNdcVO,
          i
        )
      );
    })
    .catch((response) => {
      dispatch(setDisputeActivityExportAll({}));
    });
};
export const reportNDCData = (values, i) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_ACTIVITY_GRID_NDC, values)
    .then((response) => {
      dispatch(
        setDisputeActivityExportAll(
          response?.data?.rebateDisputeActivityGridNdcVO,
          i
        )
      );
    })
    .catch((response) => {
      dispatch(setDisputeActivityExportAll({}));
    });
};
// Function to devide aaray in equal parts

function divideArray(array, parts) {
  const length = array?.length;
  let adjustedLength = length;

  if (length % parts !== 0) {
    adjustedLength = length + (parts - (length % parts));
  }

  const partSize = adjustedLength / parts;
  const dividedParts = [];
  let currentIndex = 0;

  for (let i = 0; i < parts; i++) {
    const part = array?.slice(currentIndex, currentIndex + partSize);
    dividedParts.push(part);
    currentIndex += partSize;
  }

  return dividedParts;
}
export const getMFGGridExportAll =
  (
    { rebateProgramCD, mfgId, disputeCode, openStatus, closeStatus },
    manufactureID
  ) =>
  (dispatch) => {
    dispatch(setDisputeActivityExportAll({}));

    const allMfgID = manufactureID?.map((item) => item.manufacturerID);
    const arr = divideArray(allMfgID, 4);

    for (let i = 0; i < arr.length; i++) {
      const values = {
        rebateProgramCD,
        mfgId: arr[i],
        disputeCode,
        openStatus,
        closeStatus,
      };
      dispatch(reportData(values, i));
    }
  };
export const getNDCGridExportAll =
  (
    { rebateProgramCD, drugSeqNum, disputeCode, openStatus, closeStatus },
    drugDataList
  ) =>
  (dispatch) => {
    dispatch(setDisputeActivityExportAll({}));
    const allNDCID = drugDataList?.map((item) => item.drugSeqNum);
    const arr = divideArray(allNDCID, 4);
    for (let i = 0; i < arr.length; i++) {
      const values = {
        rebateProgramCD,
        drugSeqNum: arr[i],
        disputeCode,
        openStatus,
        closeStatus,
      };
      dispatch(reportNDCData(values, i));
    }
  };

export const mfgWithDataToDisplay = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_ACTIVITY_MFG_LIST, values)
    .then((response) => response.data?.data)
    .catch((response) => []);
};
